function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u2935");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "ISPA-Microsite",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "HiraginoSans-W4, Hiragino Sans",
  fontSize: 60,
  fontWeight: "normal",
  letterSpacing: -1,
  "line-spacing": 60
}, React.createElement("g", {
  id: "Notre-ISPA-Desktop",
  transform: "translate(-1104.000000, -172.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(254.000000, 163.000000)"
}, React.createElement("text", {
  id: "\\u2935"
}, React.createElement("tspan", {
  x: 848,
  y: 53
}, "\u2935")))));

var SvgCurvedarrow = function SvgCurvedarrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "57px",
    height: "56px",
    viewBox: "0 -8 57 56",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCurvedarrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/curvedarrow.2d9af5d9.svg";
export { ForwardRef as ReactComponent };